import { createTheme } from '@mantine/core'
import { Modal } from './mantine'

const theme = createTheme({
	components: {
		Modal,
	},
})

export default theme
